import { useTranslation } from 'react-i18next';
import { CheckSquareIcon, DownloadSimpleIcon, SquareIcon } from '@phosphor-icons/react';
import {
  SECURITY_MEASURES_DESCRIPTION,
  SECURITY_SECTIONS,
  SECURITY_MEASURES_VERSIONS,
} from '@monorepo/shared';
import { useDownloadLegalPdf } from '../../services/legalDocuments.service';
import { LegalDocumentVersions } from './LegalDocumentVersions';

export const SecurityMeasuresDocument = () => {
  const { t } = useTranslation();
  const { mutate: downloadLegalPdf, isPending } = useDownloadLegalPdf();

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <h2 className="text-2xl font-display text-primary">{t('legal.security_measures.title')}</h2>
        <button
          type="button"
          onClick={() => downloadLegalPdf('security-measures')}
          disabled={isPending}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary text-white text-sm font-medium hover:opacity-90 disabled:opacity-60 disabled:cursor-not-allowed transition self-start sm:self-auto"
        >
          <DownloadSimpleIcon size={18} weight="bold" />
          {isPending ? t('common.downloading') : t('common.download_pdf')}
        </button>
      </div>

      <LegalDocumentVersions versions={SECURITY_MEASURES_VERSIONS} />

      <p className="text-text mb-8 leading-relaxed">{SECURITY_MEASURES_DESCRIPTION}</p>

      {SECURITY_SECTIONS.map(({ title, objective, items }, sectionIndex) => (
        <section key={sectionIndex} className="mb-8">
          <h3 className="text-xl font-semibold text-primary mb-2">{title}</h3>
          {objective && (
            <p className="text-sm text-secondary italic mb-4">
              {t('legal.security_measures.objective')} : {objective}
            </p>
          )}

          <div className="space-y-2">
            {items.map(({ text, checked, level }, itemIndex) => (
              <div
                key={itemIndex}
                className={`flex items-start gap-3 ${level === 2 ? 'ml-8' : ''}`}
              >
                {checked ? (
                  <CheckSquareIcon
                    size={20}
                    weight="fill"
                    className="text-green-500 flex-shrink-0 mt-0.5"
                  />
                ) : (
                  <SquareIcon
                    size={20}
                    weight="regular"
                    className="text-gray-300 flex-shrink-0 mt-0.5"
                  />
                )}
                <span className={`text-sm ${checked ? 'text-text' : 'text-gray-400'}`}>{text}</span>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};
